import React from "react";
import { SppPlayCircleFillIcon } from "./SppPlayCircleFillIcon";

const VIDEO_ASPECT_RATIO = "16 / 9";

type SppMobileVideoThumbnailProps = {
  src: string;
};

export const SppMobileVideoThumbnail: React.FC<SppMobileVideoThumbnailProps> = ({ src }) => (
  <div
    className="spp-mobile-video-thumbnail"
    style={{
      position: "relative",
      width: "100%",
      aspectRatio: VIDEO_ASPECT_RATIO,
    }}
  >
    <img
      src={src}
      alt="Video"
      style={{
        width: "100%",
        height: "100%",
        display: "block",
        objectFit: "cover",
      }}
    />
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        pointerEvents: "none",
      }}
      aria-hidden
    >
      <SppPlayCircleFillIcon />
    </div>
  </div>
);
